import { h, render, Component } from 'preact';
import { classNames, isValidUsPlusOnePhone, normalizeToUsPlusOnePhone } from '../utils/utils';
import { appConfig } from '../app.config';
import TxrInput from './txr-input';
import TxrPhoneInput from './txr-phone-input';
import TxrInputArea from './txr-input-area';
import TxrDropdown from './txr-dropdown';
import qs from 'qs';

import axios from 'axios';

class TxrPartnerForm extends Component {
    state = {
        isSubmitted: false,
        messageSent: false,
        messageError: false,
        selectedTopic: undefined,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail',
            phone: 'Use a North American number in the form +1 followed by 10 digits (example: +15551234567).'
        },
        companyTypes: [
            { title: 'Tech Company', id: 0}, 
            { title: 'Agency', id: 1}, 
            { title: 'Multi-location brand', id: 2},
            { title: 'Other', id: 3}
        ],
        heardAboutFromList: [
            { title: 'Text Request Customer', id: 0}, 
            { title: 'Google/Organic Search', id: 1}, 
            { title: 'Google Search Ad', id: 2},
            { title: 'Text Request Partner', id: 3},
            { title: 'Email Ad', id: 4},
            { title: 'Other', id: 5}
        ],
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        positionModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        partnershipMessageModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model) || this.checkEmail(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        phoneModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = this.checkRequiredInvalid(model) || this.checkPhoneInvalid(model);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        companyModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        websiteModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        companyTypesModel: {
            value: null,
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
        heardAboutFromListModel: {
            value: null,
            invalid: false,
            errors: {},
            change: (model) => {
                this.forceUpdate();
            }
        },
    }

    checkRequiredInvalid = (model) => {
        if (!this.state.isSubmitted) {
            return false;
        }
        let hasError = !model.value || !model.value.trim();
        model.errors['required'] = hasError;
        return hasError;
    }

    checkEmail = (model) => {
        let email = model.value;
        let hasError = !/^[A-Za-z0-9\-]+[A-Za-z0-9._\-]+@[A-Za-z0-9\-.]+\.[A-Za-z.]{2,}$/.test(email);
        model.errors['email'] = hasError;
        return hasError;
    }

    checkPhoneInvalid = (model) => {
        if (!this.state.isSubmitted) {
            return false;
        }
        const hasError = !isValidUsPlusOnePhone(model.value);
        model.errors['phone'] = hasError;
        return hasError;
    }
    sent = () => {
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true, messageSent: false, messageError: false });

        this.state.firstNameModel.change(this.state.firstNameModel);
        this.state.lastNameModel.change(this.state.lastNameModel);
        this.state.positionModel.change(this.state.positionModel);
        this.state.partnershipMessageModel.change(this.state.partnershipMessageModel);
        this.state.emailModel.change(this.state.emailModel);
        this.state.phoneModel.change(this.state.phoneModel);
        this.state.companyModel.change(this.state.companyModel);
        this.state.websiteModel.change(this.state.websiteModel);
        this.state.companyTypesModel.change(this.state.companyTypesModel);
        this.state.heardAboutFromListModel.change(this.state.heardAboutFromListModel);


        if (this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.positionModel.invalid || this.state.phoneModel.invalid || this.state.emailModel.invalid || this.state.companyModel.invalid) {
            return;
        }
        this.setState({ isLoading: true });
        var data =
        {
            firstName: this.state.firstNameModel.value, 
            lastName: this.state.lastNameModel.value, 
            position: this.state.positionModel.value, 
            partnershipMessage: this.state.partnershipMessageModel.value, 
            email: this.state.emailModel.value, 
            company: this.state.companyModel.value, 
            website: this.state.websiteModel.value, 
            phoneNumber: normalizeToUsPlusOnePhone(this.state.phoneModel.value) || this.state.phoneModel.value, 
            companyType: this.state.companyTypesModel.value ? this.state.companyTypesModel.value.title: null,
            heardAboutFrom: this.state.heardAboutFromListModel.value ? this.state.heardAboutFromListModel.value.title : null
        };
/*
        const d = {};
        
        for (var p in data) {
            if (!data[p]) {
                continue;
            }
            d[encodeURIComponent(p)] = encodeURIComponent(data[p]);
        }*/
       
        const url = appConfig.url + '/webservices/contact/partnership-inquiry';
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(data),
            url,
        };
        axios(options)
        // axios.post(url, params)
        .then(() => {
            this.setState({ isLoading: false, messageSent: true, messageError: false });
        })
            .catch(() => {
                this.setState({ isLoading: false, messageSent: false, messageError: true });
            })
    }
    onSubmit = e => {
        return false;
      }
    render() {
        return (
            <div class="txr-partner-form">
                {!this.state.messageSent &&
                    <form onsubmit={this.onSubmit} class="partner__form">
                        <div class="partner__form__left">
                            <div class="partner__form__item item-half txr-mr20">
                                <TxrInput model={this.state.firstNameModel} type="text" label="First name*" errors={this.state.errors}> </TxrInput>
                            </div>
                            <div class="partner__form__item item-half">
                                <TxrInput model={this.state.lastNameModel} type="text" label="Last name*" errors={this.state.errors}> </TxrInput>
                            </div>
                            <div class="partner__form__item">
                                <TxrPhoneInput model={this.state.phoneModel} type="text" label="Phone number*" placeholder="+15551234567" errors={this.state.errors}></TxrPhoneInput>
                            </div>
                            <div class="partner__form__item">
                                <TxrInputArea model={this.state.positionModel} label="Position / Title" errors={this.state.errors}></TxrInputArea>
                            </div>
                            <div class="partner__form__item">
                                <TxrInputArea model={this.state.partnershipMessageModel} label="Partnership needs?" errors={this.state.errors}></TxrInputArea>
                            </div>
                            <div class="partner__form__item txr-dropdown__selector">
                                <TxrDropdown model={this.state.heardAboutFromListModel} label="How’d you hear about us?" options={this.state.heardAboutFromList}></TxrDropdown>
                            </div>
                        </div>
                        <div class="partner__form__right">
                            <div class="partner__form__item">
                                <TxrInput model={this.state.emailModel} type="email" label="Email*" errors={this.state.errors}></TxrInput>
                            </div>
                            <div class="partner__form__item">
                                <TxrInput model={this.state.companyModel} type="text" label="Company" errors={this.state.errors}></TxrInput>
                            </div>
                            <div class="partner__form__item">
                                <TxrInput model={this.state.websiteModel} type="text" label="Website URL" errors={this.state.errors}></TxrInput>
                            </div>

                            <div class="partner__form__item txr-dropdown__selector">
                                <TxrDropdown model={this.state.companyTypesModel} label="I am with a…" options={this.state.companyTypes}></TxrDropdown>
                            </div>
                        </div>
                        <div class="partner__form__button">
                            <button class="txr-button txr-primary-button txr-width130" disabled={this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.phoneModel.invalid || this.state.emailModel.invalid && this.state.isSubmitted} type="button" onClick={() => this.sent()}>
                                <span class="txr-button__content"> SUBMIT
                                    {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                    {this.state.isLoading && <i class="fas fa-circle-notch fa-spin"></i>}
                                </span>
                            </button>
                        </div>

                    </form>
                }
                {
                    this.state.messageSent &&
                    <div class="partner__form__sent">
                        <i class="fal fa-paper-plane"></i>
                        <div class="form-sent__title">Hooray! We got your message. Thanks for submitting it.</div>
                        <div class="form-sent__hint">We’re currently routing your message to the correct person and they’ll be in touch shortly.</div>
                    </div>
                }
                {this.state.messageError &&
                    <div class="send-us-form__error">
                        An error occurred during submit feedback
                    </div>
                }
            </div>
        )
    }
}

export default TxrPartnerForm;